// Front end: Matestack's Vue runtime plus DaisyStack's sidecar components.
// Built by esbuild (package.json "build"); the matestack-ui-vuejs and
// daisy_stack aliases point at the installed gems (bin/link-daisy-stack).
// The public blog does not load this: it has blog_reading.js only.
import { createApp } from "vue";
import MatestackUiVueJs from "matestack-ui-vuejs";
import "daisy_stack/matestack_patches";

import dsFormDateInput from "daisy_stack/ui/components/forms/ds_form_date_input";
import dsFormTimeInput from "daisy_stack/ui/components/forms/ds_form_time_input";
import dsPush from "daisy_stack/ui/components/realtime/ds_push";
import toast from "../matestack/web/components/toast";

const appInstance = createApp({});
appInstance.component("ds-form-date-input", dsFormDateInput);
appInstance.component("ds-form-time-input", dsFormTimeInput);
appInstance.component("ds-push", dsPush);
appInstance.component("studio-toast", toast);

document.addEventListener("DOMContentLoaded", () => {
  MatestackUiVueJs.mount(appInstance);
});
